module.exports = __webpack_public_path__ + "img/8.94c0c021.jpg";